/**
 * pdf.js worker bekötése.
 *
 * Korábban a `?url` Vite import-tal hash-eltük az asset URL-t, de a böngésző
 * a `pdf.worker.min-<hash>.mjs` dinamikus ESM importnál
 * "Failed to fetch dynamically imported module" hibára futott.
 *
 * Most a worker fájl a `public/` mappából szolgáljuk fix path-on. Így
 * - nincs hash, nincs Vite bundling
 * - a böngésző sima ES modul scriptként tölti
 * - a verziófrissítéseknél kézzel kell újra-másolni
 *   (`cp node_modules/pdfjs-dist/build/pdf.worker.min.mjs public/`)
 */
import * as pdfjsLib from 'pdfjs-dist'

const WORKER_URL = '/pdf.worker.min.mjs'

if (typeof window !== 'undefined' && !pdfjsLib.GlobalWorkerOptions.workerSrc) {
  pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL
}

export { pdfjsLib }
